import { HostListener, Component, AfterContentChecked, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { NgbPaginationModule, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DistributionUnitSearch, DistributionUnitListBE } from '../distribution-unit/shared/distribution-unit.model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { DistributionUnitSearchService } from './distribution-unit-search.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { UserHandling } from '../shared/user-handling';
import { StatusEnum } from '../shared/enums.model';
import { NgbDateFRParserFormatter } from '../shared/ngb-date-fr-parser-formatter';
import { AttributeListBE } from '../shared/attribute-list.model';
import { AppConfig } from '../config/app.config';
import { SetFocus } from '../../app/shared/setFocus';

@Component({
    moduleId: module.id,
    selector: 'distribution-unit-search',
    templateUrl: 'distribution-unit-search.html',
    providers: [DistributionUnitSearchService, NgbPaginationConfig],
})
export class DistributionUnitSearchComponent implements OnInit, AfterContentChecked, ComponentCanDeactivate {
    listOfSearchDu: DistributionUnitSearch = undefined;
    listOfDu: Array<DistributionUnitListBE>;
    searchDuCount: number = 0;
    viewDuDlg: NgbModalRef;
    selectedDuId: number;
    user: UserHandling = new UserHandling();
    showSpinner: boolean = false;
    pagerPage: number = 1;
    collectionSize: number;
    duName: string = "";

    // model variables put in html
    seachIssuerUserId: string = '';
    searchStartDateFrom: NgbDateStruct;
    searchStartDateTo: NgbDateStruct;
    dateFormatter: NgbDateFRParserFormatter = new NgbDateFRParserFormatter();
    includeDateSpansInSearch: boolean = false;
    queryTotalRows: number = 0;

    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;


    constructor(private config: AppConfig,
        private pkgSearchService: DistributionUnitSearchService,
        private modalService: NgbModal,
        private paginationConfig: NgbPaginationConfig,
        private errHandler: ErrorHandlerService
    ) {
        paginationConfig.pageSize = 10;
        paginationConfig.ellipses = true;
        paginationConfig.directionLinks = true;
        paginationConfig.boundaryLinks = true;
        paginationConfig.maxSize = 10;
        this.collectionSize = 10;
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }

    // ----------------------------------------------------------
    // Life cycle hooks
    // ----------------------------------------------------------
    ngOnInit(): void {
        this.showSpinner = false;
        this.searchStartDateFrom = this.dateFormatter.parseToDateNow();
        this.searchStartDateTo = this.dateFormatter.parseToDateNow();
        this.listOfSearchDu = new DistributionUnitSearch;
    }
     
    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to("mhno", this.isFocusSet);
    }

    // ----------------------------------------------------------
    // Dalog boxes methods
    // ----------------------------------------------------------
    openViewDuDlg(modal: any, docVal: DistributionUnitListBE) {
        this.selectedDuId = docVal.Id;
        this.duName = docVal.MHNo;
        this.viewDuDlg = this.modalService.open(modal, { size: 'lg' });
    }


    // ----------------------------------------------------------
    // Tab record counts
    // ----------------------------------------------------------
    setCollectionsSizes() {
        this.listOfSearchDu.CreateDateFrom = this.dateFormatter.format(this.searchStartDateFrom);
        this.listOfSearchDu.CreateDateTo  = this.dateFormatter.format(this.searchStartDateFrom);
        this.includeDateSpansInSearch = this.user.IsPartSupplierUser ? false : this.includeDateSpansInSearch;

        this.pkgSearchService.listOfDuCount(this.listOfSearchDu)
            .subscribe(returnObject => this.setCollectionsSizesCountResult(returnObject));
    }

    setCollectionsSizesCountResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.error(returnObject.ErrorMsg, 'DistributionUnitSearchComponent.setCollectionsSizesCountResult', returnObject.ErrorType);
        }
        else {
            this.queryTotalRows = returnObject.DataList[0];
            if (this.queryTotalRows > 500)
                this.collectionSize = 500;
            else
                this.collectionSize = returnObject.DataList[0];

            this.pageChanger();
        }
    }

    // ----------------------------------------------------------
    // Search
    // ----------------------------------------------------------
    searchResult(returnObject: IReturnObject) {
        this.listOfDu = [];
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.error(returnObject.ErrorMsg, 'DistributionUnitSearchComponent.searchResult', returnObject.ErrorType);
        }
        else {
            this.listOfDu = returnObject.DataList;
        }
        this.showSpinner = false;
    }

    showResults() {
        this.showSpinner = true;
        this.pagerPage = 1;

        this.listOfDu = [];
        this.setCollectionsSizes();
        this.pageChanger();
    }


    // ----------------------------------------------------------
    // Pagination methods
    // ----------------------------------------------------------
    pageChanger() {
        let CreateDateFrom: string = this.dateFormatter.format(this.searchStartDateFrom);
        let CreateDateTo: string = this.dateFormatter.format(this.searchStartDateFrom);
        this.includeDateSpansInSearch = this.user.IsPartSupplierUser ? false : this.includeDateSpansInSearch;

        this.errHandler.emitErrorObject(null);
        this.showSpinner = true;
        var numToSkip = (this.pagerPage - 1) * this.paginationConfig.pageSize;

        this.pkgSearchService.listOfDu(this.listOfSearchDu)
            .subscribe(returnObject => this.searchResult(returnObject));
    }

    downloadExcel() {
        window.open(this.config.get('apiUrl') + '/DistributionUnit/CreateDUListExcel/', '_blank');
    }

    // ----------------------------------------------------------
    // Error, warning and info
    // ----------------------------------------------------------
    error(message: string, source: string, errType: ErrorTypeEnum): void {
        throw new ErrorObject(message, source, errType);
    }

    canExport(){
        let canExport = this.user.IsPackagingAdmin
        || this.user.IsDeveloper
        || this.user.IsPackagingEngineer
        || this.user.IsPurchaser;

        return canExport;
    }
    
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/distribution-unit-search/distribution-unit-search.component.ts